import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { modals } from '@/mixins/modal';
import tooltip from '@/mixins/components/tooltip';
import { getDynamicData } from '@editor/page/top-control-bar/dynamic-data/item-types';

export default Vue.component('link-dynamic', {
  template: require('./template.html'),
  name: 'link-dynamic',
  components: {
    tooltip,
  },
  props: [
    'droplet',
    'show-edit-bubble',
    'dynamic-item',
    'dynamic-item-label',
    'site-type',
    'droplet-key',
  ],
  mixins: [modals],
  computed: {
    ...mapGetters(['currentSite']),
    dynamicData() {
      return getDynamicData({ type: this.siteType });
    },
    dynamicList() {
      const enabled = this.currentSite.dynamic && this.currentSite.dynamic[this.siteType];
      const list = enabled ? _.cloneDeep(enabled.published || []) : [];
      const sortColIndex = _.findIndex(this.cols, c => c === 'created');
      const sortOn = this.sortKey || this.cols[sortColIndex];
      return _.chain(list)
        .thru((t) => {
          if (this.filterKey) {
            return _.reduce(
              t,
              (acc, row) => {
                const e = [];
                // only grab the properties that the table uses
                _.filter(row, () => {
                  _.forEach(this.cols, (c) => {
                    // clean up the values so that the
                    // searchable items are like how
                    // the template is written
                    const col = this.cleanItem(row[c], c);
                    e.push(col);
                  });
                });
                if (
                  _.filter(e, v =>
                    _(v)
                      .toLower()
                      .includes(this.filterKey.toLowerCase()),
                  ).length
                ) {
                  acc.push(row);
                }
                return acc;
              },
              [],
            );
          }
          return t;
        })
        .sort((a, b) => {
          // We'll sort accending by default and we'll also ignore case
          // since that may confuse non-technical users
          const ascDesc = this.sortMap[sortOn];
          a = _.isString(a[sortOn]) ? _.toLower(a[sortOn]) : a[sortOn]; // eslint-disable-line
          b = _.isString(b[sortOn]) ? _.toLower(b[sortOn]) : b[sortOn]; // eslint-disable-line
          return (a === b ? 0 : a < b ? -1 : 1) * ascDesc; // eslint-disable-line
        })
        .value();
    },
  },
  watch: {
    dynamicModal(open) {
      if (open) {
        this.activeData = null;
        this.confirmReplace = false;
      }
    },
  },
  data() {
    return {
      cols: [],
      sortMap: {},
      paginate: ['dynamicList'],
      dynamicModal: false,
      filterKey: '',
      sortKey: '',
      activeData: null,
      confirmReplace: false,
      confirmUnlink: false,
    };
  },
  created() {
    this.cols = this.dynamicData.table;
    this.sortMap = _.zipObject(this.cols, _.fill(Array(this.cols.length), -1));
  },
  methods: {
    linkDynamic() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key: this.dropletKey,
        val: this.activeData._id,
      });
      this.activeData = null;
      this.confirmReplace = false;
      this.openDynamicData();
      this.$emit('on-link', this.activeData);
    },
    unlinkDynamic() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key: this.dropletKey,
        val: null,
      });
      this.confirmUnlink = false;
      this.$emit('on-unlink', this.activeData);
    },
    openDynamicData() {
      this.dynamicModal = !this.dynamicModal;
      const content = this.$refs.dynamicModal;
      if (this.dynamicModal) {
        this.modelMoveOut(content);
      } else {
        this.modalMoveIn(content);
      }
    },
    confirmLink(item) {
      this.activeData = item;
      this.confirmReplace = true;
    },
    setSortKey(k) {
      this.sortKey = k;
      // Invert the value for ascDesc
      this.sortMap[k] = this.sortMap[k] * -1;
    },
    seperateCamalCase(str, mobile) {
      const tail = mobile ? ': ' : '';
      return str.replace(/([A-Z])/g, g => ` ${g[0].toLowerCase()}`) + tail;
    },
    highlight(ctx, query, col, it) {
      const c = this.cleanItem(ctx, col, it);
      return c.replace(
        new RegExp(query, 'ig'),
        match => `<span class='editorUi-searchHighlight'>${match}</span>`,
      );
    },
    cleanHeader(text) {
      return _.startCase(text);
    },
    cleanItem(item, col) {
      let i = item || '--';
      if (col === 'created' && i !== '--') {
        i = this._zoneFormat({
          date: i,
          format: 'MM-DD-YYYY hh:mm A z',
          zone: this.currentSite.timezone,
        });
      }
      return typeof i === 'string' ? i : i.toString();
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/_bubble-options/components/link-dynamic/index.js